import { render, staticRenderFns } from "./VFileUpload.vue?vue&type=template&id=7bc60084&"
import script from "./VFileUpload.vue?vue&type=script&lang=ts&"
export * from "./VFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./VFileUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports